import React from 'react'
import { Link } from 'react-router-dom'
import V2Layout from '../components/V2Layout'

const PageNotFound = () => {
    return (
        <V2Layout pageClass="pfc-not-found">

            <section className="pfc-page-hero">
                <div className="pfc-page-hero-inner" style={{ textAlign: 'center', maxWidth: '640px' }}>
                    <p className="v2-section-label">404</p>
                    <h1 className="pfc-page-hero-title">Page Not Found</h1>
                    <p className="pfc-page-hero-sub" style={{ margin: '0 auto' }}>
                        The page you are looking for does not exist or may have been moved.
                    </p>
                    <div className="pfc-not-found-actions">
                        <Link to="/" className="v2-btn-primary">Back to Home</Link>
                        <Link to="/contactus" className="v2-btn-outline">Contact Us</Link>
                    </div>
                </div>
            </section>

        </V2Layout>
    )
}

export default PageNotFound
